module.exports = __webpack_public_path__ + "bcb927a742a8370b76642fd1a9a749c0.woff";